import { render, staticRenderFns } from "./modalEditarPolitica.vue?vue&type=template&id=02827532&scoped=true"
import script from "./modalEditarPolitica.vue?vue&type=script&lang=js"
export * from "./modalEditarPolitica.vue?vue&type=script&lang=js"
import style0 from "./modalEditarPolitica.vue?vue&type=style&index=0&id=02827532&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02827532",
  null
  
)

export default component.exports